module.exports = __webpack_public_path__ + "static/work_BigBang_Mega-1a3aa7b296fb4ee60c790b049d416350.jpeg";